import api from './api';
import pick from 'lodash/pick';

/**
 * @param {{
 *  task_type_id: string
 *  rubric_id: string
 *  rubric_text: string
 *  rubric_audio_id: string
 *  helper_text: string
 *  helper_audio_id: string
 * }} rubric
 * @returns {Promise<{
 *  updated: boolean,
 *  rubric_id: string
 *  rubric_text: string
 *  helper_text: string
 *  rubric_audio_id: string
 *  helper_audio_id: string
 *  skill_id: string
 *  phase: string
 *  task_type_id: string
 * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Rubrics-puttRubrics
 */
export default async function updateRubric(rubric) {

    const { data } = await api.put(
        `rubrics/${rubric.rubric_id}`,
        pick(rubric, [
            'rubric_text',
            'rubric_audio_id',
            'phase'
        ])
    );

    return data;
}